export default {
    title: "我的商品",
    nothing: "暫無商品，請聯繫管理員添加！"
}